import React from 'react'
import PropTypes from 'prop-types'

const Inputbox = ({ label, placeholder, starField, endAdornment, ...props }) => {
  return (
    <div className="custom_input-container">
      <div className="input-label">
        <span >
          {label}
          {starField && <span className="required-star"> *</span>}
        </span>
      </div>

      <div className='input-wrapper'>
        <input className="input-box" placeholder={placeholder} {...props} />
        {endAdornment && (
          <div className="end-adornment">
            {endAdornment}
          </div>
        )}
      </div>


    </div>
  )
}

Inputbox.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  starField: PropTypes.bool,
  endAdornment: PropTypes.node,
}

export default Inputbox
